// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"styles_modalWrapper__1Q4Np","title":"styles_title__3IkNm","desc":"styles_desc__gSA-W"};